'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ChatHead = require('./ChatHead');

var _ChatHead2 = _interopRequireDefault(_ChatHead);

var _responderGetters = require('conversations-schema/responders/operators/responderGetters');

var _isAvailable = require('conversations-schema/operators/agent-state/isAvailable');

var _getChatHeadGroupStyle = require('../util/getChatHeadGroupStyle');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getChatHeadClassName(total, index) {
  switch (true) {
    case total === 3 && index === 0:
      return 'chat-head-left chat-head-shrink';
    case total === 3 && index === 1:
      return 'chat-head-center';
    case total === 3 && index === 2:
      return 'chat-head-right chat-head-shrink';
    case total === 2 && index === 0:
      return 'chat-head-left';
    case total === 2 && index === 1:
      return 'chat-head-right';
    default:
      return '';
  }
}

function ChatHeadGroup(_ref) {
  var showStatusIndicator = _ref.showStatusIndicator,
      size = _ref.size,
      responders = _ref.responders,
      mobile = _ref.mobile;

  var numResponders = responders.size;

  var chatHeadElements = responders.map(function (responder, index) {
    var avatar = (0, _responderGetters.getAvatar)(responder);
    var online = (0, _isAvailable.isAvailable)(responder);
    var isBot = (0, _responderGetters.getIsBot)(responder);
    var userId = (0, _responderGetters.getUserId)(responder);
    var className = getChatHeadClassName(numResponders, index);

    return _react2.default.createElement(_ChatHead2.default, {
      key: 'chat-head.' + userId,
      className: className,
      size: size,
      avatar: avatar,
      online: online,
      responder: responder,
      isBot: isBot,
      showStatus: showStatusIndicator,
      isVisitorWidget: true
    });
  });

  return _react2.default.createElement(
    'div',
    { className: 'justify-center', style: (0, _getChatHeadGroupStyle.getChatHeadGroupStyle)({ mobile: mobile }) },
    chatHeadElements
  );
}

ChatHeadGroup.propTypes = {
  mobile: _react.PropTypes.bool,
  responders: _react.PropTypes.instanceOf(_immutable.List).isRequired,
  showStatusIndicator: _react.PropTypes.bool.isRequired,
  size: _react.PropTypes.string.isRequired
};

ChatHeadGroup.defaultProps = { showStatusIndicator: false };

exports.default = ChatHeadGroup;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-components/static-1.4266/js/visitor-widget/ChatHeadGroup.js
// module id = 1051
// module chunks = 2 3